import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { createNotification } from '../notifications/notifications'
import { notificationsLibrary } from '../../utils/notificationsLibrary'

const ModalForm = ({ modalData, addNewBookToOrder, modalHandler, deleteRequest }) => {
  const [bookForm, setBookForm] = useState({
    title: '',
    author: '',
    isbn: '',
    publisher: '',
    year: 0,
    amount: 0,
    digital_amount: 0,
    bookid: null,
  })
  const [bookFormError, setBookFormError] = useState('')

  const handleChange = event => {
    setBookForm({
      ...bookForm,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = event => {
    event.preventDefault()
    const isBothCountersZero = bookForm.amount === 0 && bookForm.digital_amount === 0

    if (!isBothCountersZero) {
      addNewBookToOrder(bookForm, modalData.id)
        .then(() => createNotification('success', notificationsLibrary['01']))
        .catch(() => createNotification('error', notificationsLibrary['06']))
      setBookFormError('')
    } else {
      setBookFormError('Количество бумажных и электронных копий не могут быть одновременно равны 0')
    }
  }

  return (
    <div>
      <form className='smallModalForm' onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <label className='smallInputLabel'>Название книги</label>
            <input type='text' name='title' onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>Автор</label>
            <input type='text' name='author' onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>Издательство</label>
            <input type='text' name='publisher' onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>Год</label>
            <input type='text' name='year' onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>ISBN</label>
            <input type='text' name='isbn' onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>Количество бумажных копий</label>
            <input type='number' name='amount' min='0' max='1000000' value={bookForm.amount} onChange={handleChange} />
          </Col>
          <Col md={6}>
            <label className='smallInputLabel'>Количество электронных копий</label>
            <input
              type='number'
              name='digital_amount'
              min='0'
              max='1000000'
              value={bookForm.digital_amount}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row className='justify-content-end'>
          <Col>{bookFormError && <span className='form_error'>{bookFormError}</span>}</Col>
          <Col md={'auto'}>
            <button type='submit' className='btn'>
              Добавить книгу
            </button>
          </Col>
        </Row>
      </form>
      <Row className='justify-content-end'>
        <Col md={'auto'}>
          <button type='button' className='btn mr-3' onClick={() => deleteRequest(modalData.id)}>
            Удалить заказ
          </button>
          <button type='button' className='btn btn-empty' onClick={() => modalHandler(false)}>
            Ок
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default ModalForm
